import AddNew from "./AddNew";
import Customers from "./Customers";

export default { AddNew, Customers };
